import { render, staticRenderFns } from "./RequestsMenu.vue?vue&type=template&id=2c78848b"
import script from "./RequestsMenu.vue?vue&type=script&lang=js"
export * from "./RequestsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports